import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NgxAdclMaterialModule } from '@adcl/ngx-material';
import { LoadingIndicatorService } from '../services/loading-indicator.service';

@Component({
  selector: 'app-mareon-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule, NgxAdclMaterialModule],
})
export class LoadingIndicatorComponent implements OnInit {
  private readonly loadingIndicatorService = inject(LoadingIndicatorService);

  constructor() {}

  isIndicatorActiv() {
    return this.loadingIndicatorService.showLoading;
  }

  ngOnInit() {}
}
